import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CSS = `
.cg-field { display: flex; flex-direction: column; gap: var(--space-2); font-family: var(--font-sans); }
.cg-field__label {
  font-size: var(--text-xs); font-weight: var(--weight-semibold);
  color: var(--text-body); display: flex; align-items: center; gap: var(--space-1);
}
.cg-field__req { color: var(--danger); }
.cg-input__wrap { position: relative; display: flex; align-items: center; }
.cg-input__icon {
  position: absolute; left: 12px; display: inline-flex; color: var(--text-subtle);
  pointer-events: none;
}
.cg-input__icon svg { width: 16px; height: 16px; }
.cg-input {
  width: 100%; height: var(--control-h-md); box-sizing: border-box;
  padding: 0 var(--space-3); font-family: var(--font-sans); font-size: var(--text-base);
  color: var(--text-heading); background: var(--surface-card);
  border: 1px solid var(--border-default); border-radius: var(--radius-md);
  transition: border-color var(--duration-fast) var(--ease-standard),
              box-shadow var(--duration-fast) var(--ease-standard);
}
.cg-input::placeholder { color: var(--text-subtle); }
.cg-input--icon { padding-left: 36px; }
.cg-input:hover { border-color: var(--border-strong); }
.cg-input:focus { outline: none; border-color: var(--brand-primary); box-shadow: var(--shadow-focus); }
.cg-input:disabled { background: var(--slate-100); color: var(--text-subtle); cursor: not-allowed; }
.cg-input--invalid { border-color: var(--danger); }
.cg-input--invalid:focus { box-shadow: 0 0 0 3px var(--red-50); }
.cg-field__hint { font-size: var(--text-xs); color: var(--text-muted); }
.cg-field__hint--error { color: var(--danger); }
`;
function injectStyles() {
    if (typeof document !== 'undefined' && !document.getElementById('cg-input-css')) {
        const s = document.createElement('style');
        s.id = 'cg-input-css';
        s.textContent = CSS;
        document.head.appendChild(s);
    }
}
export function Input({ label, required, icon, hint, error, id, className = '', ...rest }) {
    injectStyles();
    const fid = id ?? `cg-input-${Math.random().toString(36).slice(2, 8)}`;
    const invalid = Boolean(error);
    return (_jsxs("div", { className: "cg-field", children: [label && (_jsxs("label", { className: "cg-field__label", htmlFor: fid, children: [label, required && _jsx("span", { className: "cg-field__req", children: " *" })] })), _jsxs("div", { className: "cg-input__wrap", children: [icon && _jsx("span", { className: "cg-input__icon", children: icon }), _jsx("input", { id: fid, required: required, className: [
                            'cg-input',
                            icon ? 'cg-input--icon' : '',
                            invalid ? 'cg-input--invalid' : '',
                            className,
                        ].filter(Boolean).join(' '), "aria-invalid": invalid || undefined, ...rest })] }), (error || hint) && (_jsx("span", { className: `cg-field__hint${error ? ' cg-field__hint--error' : ''}`, children: error || hint }))] }));
}
